import type { ProjectPriority } from '@/api/hooks'

export const PROJECT_PRIORITY_FILTER_OPTIONS = ['all', 'high', 'standard', 'low'] as const
export type ProjectPriorityFilterValue = (typeof PROJECT_PRIORITY_FILTER_OPTIONS)[number]

/** The query value for a project priority filter choice: nothing for "all" (USA-1451). */
export function projectPriorityParam(value: ProjectPriorityFilterValue): ProjectPriority | undefined {
  return value === 'all' ? undefined : value
}
